import { hostname, request, requestMultipart } from './client';
import type { RequestOptions } from './client';

export function fetchUrlPreviewImage(url: string = '', requestOptions: RequestOptions = {}) {
  return request(
    'POST',
    '/v1/account/media/urlpreview',
    {},
    {
      url,
    },
    { skipDefaultErrorHandler: true, ...requestOptions }
  );
}

export function updateImage(hash: string, payload: { focus_x: number; focus_y: number }) {
  return request('POST', `/v1/account/media/images/${hash}`, {}, payload, { skipDefaultErrorHandler: true });
}

/**
 * Uploads one image and returns the created `images` row.
 *
 * `class: 0` is the generic image class — the same value every caller in the dashboard sends.
 */
export function uploadImage(file: File, imageClass = 0) {
  const formData = new FormData();
  formData.append('image', file);

  return requestMultipart('POST', '/v1/account/media/images/upload', { class: imageClass }, formData);
}

/** The public jump URL of an `images` row, or null when there is no id to point at. */
export function mediaImageUrl(id: number | string | null | undefined): string | null {
  if (!id) return null;

  return `${hostname}/v1/media/images/${id}/jump`;
}
